<div class="autocomplete-container mt-6 relative">
  <p-autoComplete
    #autocomplete
    [(ngModel)]="option"
    (onBlur)="show = false"
    (onFocus)="show = true"
    (onShow)="show = true"
    [suggestions]="sugerencias()"
    (completeMethod)="buscar($event)"
    appendTo="body"
    (ngModelChange)="limpiarInput()"
    [multiple]="multiple"
    [optionLabel]="propiedad"
  >
    <ng-template pTemplate="loadingicon">
      <svg
        class="icon"
        width="20px"
        height="20px"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 3.33782C8.47087 2.48697 10.1786 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 10.1786 2.48697 8.47087 3.33782 7"
          stroke="#900c23"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    </ng-template>
  </p-autoComplete>
  <label
    class="label absolute top-1/2 -translate-y-1/2 left-0 pointer-events-none"
    [ngClass]="{
      'label-active':
        show || (option() ? option().length > 0 : false) || valorInput,
    }"
  >
    {{ etiqueta }}
  </label>
  <label
    class="place absolute pl-2 top-1/2 -translate-y-1/2 left-0 pointer-events-none"
    [ngClass]="{
      'opacity-100':
        show && !(option() ? option().length > 0 : false) && !valorInput,
      'opacity-0':
        !show || (option() ? option().length > 0 : false) || valorInput,
    }"
  >
    {{ placeholder }}
  </label>
  <div
    class="underline"
    [ngClass]="{ 'underline-show': show, 'underline-hide': !show }"
  ></div>
</div>
